// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2R5XT","vLegacy":"SelectSecondary_vLegacy__2eiuw","error":"SelectSecondary_error__5dDHA","disabled":"SelectSecondary_disabled__2eWo_"};